import { render, staticRenderFns } from "./ClientContainer.vue?vue&type=template&id=4d290aa8&"
import script from "./ClientContainer.vue?vue&type=script&lang=js&"
export * from "./ClientContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d290aa8')) {
      api.createRecord('4d290aa8', component.options)
    } else {
      api.reload('4d290aa8', component.options)
    }
    module.hot.accept("./ClientContainer.vue?vue&type=template&id=4d290aa8&", function () {
      api.rerender('4d290aa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientContainer.vue"
export default component.exports